import React from 'react';
import Header from '../../components/header/Header';
import Blogbox from './component/Blogbox';
import Footer from '../../components/footer/Footer'
import { useLocation } from 'react-router-dom';

const Blog = () => {
    const location = useLocation();
    console.log("locationBlog", location?.pathname);
    return (
        <>
        
            <Header />
            
            <section className='ourServices'>
                <div className="container">
                    <div className="osLeft">
                        <h2>Blog</h2>
                    </div>
                    <div className="osRight">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.
                        </p>
                    </div>
                </div>
            </section>

            <section className='BlogArea'>
                <div className="container">
                    <div className="row gy-5">
                        <Blogbox />
                    </div>
                </div>
            </section>
            
            <Footer />
        </>
    )
}

export default Blog;